import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslatePipe } from '@ngx-translate/core';
import { MetricState } from '../../../../Shared/Types/metric-state.type';

@Component({
  selector: 'av-metric-tile',
  standalone: true,
  imports: [MatIconModule, MatTooltipModule, TranslatePipe],
  templateUrl: './metric-tile.component.html',
  styleUrl: './metric-tile.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'd-block h-100' },
})
export class MetricTileComponent {
  readonly label = input.required<string>();
  readonly value = input<string>('');
  readonly caption = input<string>('');
  readonly icon = input<string>('insights');
  readonly state = input<MetricState>('loading');
  readonly source = input<string>('');
  readonly note = input<string>('');
}
